import { ENUM_DIR_CAROUSELPLATFORM } from "@platform/react-storybook/Component/Carousel/types";
import type { PropElement, PropTypes, PropDefaults } from "@platform/react-storybook/Component";

import type { LogoUuidVectorAsset } from "@common/content/asset/vector";

import Namespace from "./_index.scss";

export const { NAME_SCHOLARSHIP, TYPE_SCHOLARSHIP } = Namespace;

export const DURATION_SCHOLARSHIP = 15;

export const DIRECTION_SCHOLARSHIP = [
    ENUM_DIR_CAROUSELPLATFORM.ltr,
    ENUM_DIR_CAROUSELPLATFORM.rtl,
] as const;

export type PropScholarship = PropElement & {
    /** Notification button action*/
    onClick: () => void;
    /** A list of vector uuids with a `logo-` prefix */
    logos: LogoUuidVectorAsset[];
};

export const DEF_SCHOLARSHIP: PropDefaults<PropScholarship> = {};

export type PropTypesScholarship = PropTypes<PropScholarship, typeof DEF_SCHOLARSHIP>;
